export default "__VITE_ASSET__Brb7wbet__"